import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { winstonConfig } from '../common/logger/winston.config';
import { PerfilesController } from './perfiles.controller';
import { PerfilesService } from './perfiles.service';

@Module({
  imports: [PrismaModule],
  controllers: [PerfilesController],
  providers: [PerfilesService],
})
export class PerfilesModule {}
